<template>
  <b-overlay
    :show="busy"
    rounded
    opacity="0.6"
    spinner-small
    spinner-variant="secondary"
    class="d-inline-block"
  >
    <b-button
      v-bind="$attrs"
      @click="() => dowloadInvoicePdf()"
      variant="secondary"
      style="padding: 1px 12px;"
    >
      Baixar
    </b-button>
  </b-overlay>
</template>

<script>
import { dateWithoutHourFormat } from '../../../../utils';
import { Api } from '../../../../vue/api';
const API = new Api();

export default {
  props: {
    invoice: {
      type: Object,
      required: true,
      default: {},
    },
  },
  data() {
    return {
      busy: false,
    };
  },
  methods: {
    /**
     * Faz o download de um PDF de fatura.
     *
     * @async
     * @returns {Promise<void>} Uma promessa que é resolvida quando o download é concluído.
     *
     * @example
     * // Chama o método para baixar o PDF da fatura
     * downloadInvoicePdf();
     */
    async dowloadInvoicePdf() {
      this.busy = true;
      const {
        nossoNumero,
        codigoSolicitacao,
        name,
        installationNumber,
        dueDate,
        boletoVeins,
      } = this.invoice;
      const idBoleto = codigoSolicitacao || nossoNumero;

      const { model, ok, errors } = await API.post('/execute', {
        path: `/get-boleto-pdf/${idBoleto}`,
        method: 'get',
      });

      if (!ok) {
        this.$bvToast.toast(errors.message, {
          title: `Erro`,
          variant: 'error',
          solid: true,
        });
        this.busy = false;
        return;
      }

      const stringBase64 = model;
      const byteCharacters = atob(stringBase64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });

      const url = URL.createObjectURL(blob);
      const fileName = `${name}_${installationNumber}_${dateWithoutHourFormat(
        dueDate,
      )}_${boletoVeins}.pdf`;

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      link.click();

      this.busy = false;
      this.$bvToast.toast('Download realizado com sucesso', {
        title: `Sucesso`,
        variant: 'success',
        solid: true,
      });
    },
  },
};
</script>
